import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type MadeOffersCountVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
  currentDate: Types.Scalars['timestamp'];
}>;


export type MadeOffersCount = { madeOffersCount: { aggregate: Types.Maybe<Pick<Types.Offer_Aggregate_Fields, 'count'>> } };



export const MadeOffersCountDocument = /*#__PURE__*/ `
    query MadeOffersCount($publicKey: String!, $currentDate: timestamp!) {
  madeOffersCount: offer_aggregate(
    where: {buyer: {_eq: $publicKey}, acceptedAt: {_is_null: true}, canceledAt: {_is_null: true}, status: {_nin: ["EXPIRED", "CANCELED"]}, expiresAt: {_gt: $currentDate}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

export const useMadeOffersCount = <
      TData = MadeOffersCount,
      TError = ClientError
    >(
      variables: MadeOffersCountVariables,
      options?: Omit<UseQueryOptions<MadeOffersCount, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MadeOffersCount, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MadeOffersCount, TError, TData>(
      {
    queryKey: ['MadeOffersCount', variables],
    queryFn: hasuraFetcher<MadeOffersCount, MadeOffersCountVariables>(MadeOffersCountDocument, variables),
    ...options
  }
    )};

useMadeOffersCount.getKey = (variables: MadeOffersCountVariables) => ['MadeOffersCount', variables];

export const useInfiniteMadeOffersCount = <
      TData = InfiniteData<MadeOffersCount>,
      TError = ClientError
    >(
      variables: MadeOffersCountVariables,
      options: Omit<UseInfiniteQueryOptions<MadeOffersCount, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MadeOffersCount, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MadeOffersCount, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MadeOffersCount.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<MadeOffersCount, MadeOffersCountVariables>(MadeOffersCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMadeOffersCount.getKey = (variables: MadeOffersCountVariables) => ['MadeOffersCount.infinite', variables];


useMadeOffersCount.fetcher = (variables: MadeOffersCountVariables, options?: RequestInit['headers']) => hasuraFetcher<MadeOffersCount, MadeOffersCountVariables>(MadeOffersCountDocument, variables, options);
